export default __webpack_public_path__ + "static/media/hack.1233c048.svg";